import * as React from "react";
import { createSvgIcon } from "@material-ui/core/utils";
export var iconPath = (React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M12 16l-6-6h12l-6 6z" }));
export default createSvgIcon(iconPath, "ArrowFillDown");
//# sourceMappingURL=ArrowFillDownIcon.js.map